import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { DropdownModule } from 'ng2-bootstrap/dropdown';
import { UsersRoutingModule } from './users-routing.module';
import { TabsModule } from 'ng2-bootstrap/tabs'; 

import { UsersComponent } from './users.component';  
import { AgencyComponent } from './agency.component';  
import { RepoagencyComponent } from './repoagency.component'; 
import { ViewagencyComponent } from './viewagency.component';  
import { ViewuserComponent } from './viewuser.component'; 

import { NgxPaginationModule } from 'ngx-pagination';

import { UserService } from '../_Services/user.service';
import { AgencyService } from '../_Services/agency.service';

import { AddComponent } from './add.component';
import { EditComponent } from './edit.component';
import { MyaccountComponent } from './myaccount.component';

import { CommonService } from '../_Services/common.service'; 
@NgModule({
  imports: [
    UsersRoutingModule,
    ChartsModule,
    DropdownModule,
    NgxPaginationModule,
    CommonModule,
    FormsModule,
    TabsModule
  ],
  declarations: [ 
	UsersComponent, 
	ViewuserComponent,
	AgencyComponent,
	ViewagencyComponent,
	RepoagencyComponent,
  AddComponent,
  MyaccountComponent,
  EditComponent
  ],
  providers: [
    UserService,
    AgencyService,
    CommonService
  ]
})
export class UsersModule { }
 


// WEBPACK FOOTER //
// ./src/app/users/users.module.ts